module.exports = __webpack_public_path__ + "1d76c7bf4818d603e4eac4ed3468740f.png";